import { render, staticRenderFns } from "./SettingApp.vue?vue&type=template&id=2cde9428&scoped=true&"
import script from "./SettingApp.vue?vue&type=script&lang=ts&"
export * from "./SettingApp.vue?vue&type=script&lang=ts&"
import style0 from "./SettingApp.vue?vue&type=style&index=0&id=2cde9428&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cde9428",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VRow,VTooltip})
